module.exports = __webpack_public_path__ + "static/media/dont1.0889f315.png";